import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import { SIGNIN_USER, SIGNOUT_USER } from "constants/ActionTypes";
import requisicaoApiSeguranca from 'util/ApiSeguranca';
import { decodificarPayloadJwt } from 'util/jwt';
import {showAuthMessage, userSignInSuccess, userSignOutSuccess } from "actions/Auth";
import md5 from 'md5';

// Login migrado da API legada (POST /seguranca/auth) para a Uzerpass.Seguranca (ver
// docs/plano-integracao-api-seguranca.md). A senha continua pré-hasheada com MD5 aqui —
// não trocar isso agora: o hash salvo pros usuários migrados (ex.: adminUzer) é
// bcrypt(md5hex), justamente para aceitar o que este frontend já manda. Só muda quando
// existir uma migração real de senha (reset em texto puro), o que não é esta tarefa.
const signInUserWithEmailPasswordRequest = async (login, senha) =>
  await requisicaoApiSeguranca.post('/auth/login', { "login": login, "senha": senha })
    .then(authUser => authUser)
    .catch(error => error);

function* signInUserWithEmailPassword({payload}) {
  const {login, senha} = payload;
  try {
    const signInUser = yield call(signInUserWithEmailPasswordRequest, login, md5(senha));

    if (signInUser.isAxiosError || !signInUser.data || !signInUser.data.accessToken) {
      const mensagemErro = signInUser.response && signInUser.response.data && signInUser.response.data.notifications
        ? signInUser.response.data.notifications.map(n => n.message).join('; ')
        : 'Login ou senha inválidos';

      yield put(showAuthMessage(mensagemErro));
      return;
    }

    const { accessToken, usuario } = signInUser.data;

    localStorage.setItem("token", JSON.stringify(accessToken));

    // A resposta de login da Uzerpass.Seguranca não traz o id numérico legado (usuario.id
    // agora é um Guid) — mas o token carrega a claim "idUsuario" (id de
    // luxprod.usuario_sistema, adicionada em GeradorToken.cs justamente pra isso) pra quem
    // já foi migrado. Extrai do token pra manter localStorage['user_id'] funcionando do
    // mesmo jeito pro resto do app, que ainda depende desse id numérico em chamadas ao
    // backend legado. Usuários sem contraparte legada (sem essa claim) não têm um id
    // numérico válido — nesse caso guarda o Guid mesmo, mas qualquer código que espere um
    // número vai quebrar (esperado até a migração completa de usuários).
    const claims = decodificarPayloadJwt(accessToken);
    const idUsuarioLegado = claims && claims.idUsuario ? claims.idUsuario : usuario.id;

    localStorage.setItem('user_id', idUsuarioLegado);
    localStorage.setItem('user', usuario.nome);
    localStorage.removeItem('user_img'); // não vem mais do login; ver docs/plano-integracao-api-seguranca.md

    // Não despacha carregaMeuContexto aqui: quem faz isso agora é o componentDidMount do
    // MainApp (app/index.js), que roda tanto no login quanto em qualquer carregamento novo
    // da página (F5, reabrir com token salvo) — um só disparo pros dois casos, ver comentário
    // lá. userSignInSuccess já muda authUser, o que faz containers/App.js redirecionar pra
    // /app/inicio e montar o MainApp.
    yield put(userSignInSuccess(idUsuarioLegado));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signOut() {
  try {
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      localStorage.removeItem('tokenComunicacao'); // limpa resíduo de sessões antigas (chave não é mais gravada)
      localStorage.removeItem('user')
      localStorage.removeItem('user_img')
      localStorage.removeItem('cad_simplif_perfil')
      localStorage.removeItem('cad_simplif_insert')
      localStorage.removeItem('cad_simplif_remove')
      localStorage.removeItem('idClienteFixado')
      localStorage.removeItem('nomeClienteFixado')
      localStorage.removeItem('imgClienteFixado')
      yield put(userSignOutSuccess(signOutUser));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
  yield all([fork(signInUser),
    fork(signOutUser)]);
}
